import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SessionInfo } from '../../Models/Models/Session/SessionInfo';

declare var IS_RUNNING_IN_APP_POOL;

export class ExtendSessionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(): Promise<SessionInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Session/ExtendSession/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.post<SessionInfo, any>(url, data);
  }
}

